import { useAuth } from "@/context/AuthContext";
import { TerminalSquare, LogOut, Circle } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  return (
    <header
      className="sticky top-0 z-30 border-b backdrop-blur-xl"
      style={{ background: "rgba(7,10,16,0.85)", borderColor: "var(--border-subtle)" }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center border"
            style={{ background: "var(--bg-elevated)", borderColor: "var(--border-subtle)" }}>
            <TerminalSquare className="w-5 h-5 text-blue-500" />
          </div>
          <div className="leading-tight">
            <div className="font-extrabold tracking-tight text-lg">LUNA <span className="text-blue-500">AI</span></div>
            <div className="text-[10px] uppercase tracking-wider hidden sm:block" style={{ color: "var(--text-muted)" }}>
              Oto Sinyal Terminali
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <div data-testid="header-system-status"
            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg border"
            style={{ borderColor: "var(--border-subtle)", color: "var(--text-secondary)" }}>
            <Circle className="w-2 h-2 fill-emerald-500 text-emerald-500 pulse-glow" />
            <span className="hidden sm:inline">Aktif</span>
          </div>
          <span className="text-xs hidden md:inline" style={{ color: "var(--text-muted)" }}>
            {user?.username}
          </span>
          <button
            data-testid="header-logout-button"
            onClick={logout}
            className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border transition-colors hover:brightness-125"
            style={{ borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5", background: "rgba(239,68,68,0.08)" }}
          >
            <LogOut className="w-3.5 h-3.5" /> Çıkış
          </button>
        </div>
      </div>
    </header>
  );
}
